import { makeAutoObservable, runInAction } from "mobx";
import { makePersistable } from "mobx-persist-store";

export default class SubscriptionStore {
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "SubscriptionStore",
      properties: ["subscriptions", "subscriptionAnalysis"],
    });
  }

  subscriptions = [];
  subscriptionAnalysis = [];

  reset = () => {
    this.subscriptions = [];
    this.subscriptionAnalysis = [];
  };

  setSubscriptions = async (data) => {
    runInAction(() => {
      this.subscriptions = data;
    });
  };
  setSubscriptionAnalysis = async (data) => {
    runInAction(() => {
      this.subscriptionAnalysis = data;
    });
  };
}
